import React, { useState } from 'react';
import './WarningCard.scss';
import utilityWarning from '../../../public/assets/img/utility-warning-triangle.svg';
import ContactSupprot from '../pop-over/ContactSupport';
import { CONTACT_SUPPORT, DATA1, DATA2 } from '../../constants/contactSupportConstants';

const WarningCard = () => {

	const contactSupport = () => {
		setOpenHelpPopOver(true)
	}
	const [openHelpPopOver, setOpenHelpPopOver] = useState(false);

	const handleHelpPopOverClose = () => {
		setOpenHelpPopOver(false)
	}

	return (
		<>
			<div className='warning-border flex1'>
				<div className='flex'>
				<div><img src={utilityWarning}></img></div>
				<div className='warning-text'>
					<b className='fontWeigth700'>{DATA1}</b> {DATA2}
				</div>
				</div>
				<div className='contactSupport' onClick={contactSupport} data-testid='contactSupport'>{CONTACT_SUPPORT}</div>
			</div>

			<ContactSupprot
				open={openHelpPopOver}
				onClose={(value) => handleHelpPopOverClose(value)}
				top_text= 'yes'
			></ContactSupprot>
		</>
	);
};

export default WarningCard;
